"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DmsDragAndDropGrid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactGridLayout = _interopRequireWildcard(require("react-grid-layout"));
var _reactResizable = require("react-resizable");
var _dmsbasereact = require("dmsbasereact");
require("react-grid-layout/css/styles.css");
require("react-resizable/css/styles.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * DmsDragAndDropGrid is a component that allows you to create draggable and resizable grid layouts.
 * Each item in the grid can be moved and resized by the user.
 * 
 * Props:
 * - gadgetData: An array of objects, each containing an `id` and a `gadget` component to be displayed in the grid.
 * - initialWidth (optional): The initial width of the grid items. Defaults to 3.
 * - initialHeight (optional): The initial height of the grid items. Defaults to 3.
 * 
 * Example usage:
 * ```jsx
 * const YourComponent1 = () => (
 *     <div style={{ backgroundColor: 'lightblue', padding: '10px', border: '1px solid #ccc' }}>
 *       Component 1
 *     </div>
 * );
 * 
 * const YourComponent2 = () => (
 *     <div style={{ backgroundColor: 'lightgreen', padding: '10px', border: '1px solid #ccc' }}>
 *       Component 2
 *     </div>
 * );
 * 
 * const gadgetData = [
 *     { id: 1, gadget: YourComponent1 }, 
 *     { id: 2, gadget: YourComponent2 }, 
 * ];
 * 
 * return (
 *     <DmsDragAndDropGrid gadgetData={gadgetData} />
 * );
 * ```
 */
const DmsDragAndDropGrid = _ref => {
  let {
    gadgetData,
    initialWidth = 3,
    initialHeight = 3
  } = _ref;
  const ReactGridLayout = (0, _reactGridLayout.WidthProvider)(_reactGridLayout.default);
  const initialLayout = gadgetData.map((content, index) => ({
    x: index,
    y: 0,
    w: initialWidth,
    h: initialHeight,
    i: (0, _dmsbasereact.generate_random_id)()
  }));
  const [layout, setLayout] = (0, _react.useState)(initialLayout);
  const handleLayoutChange = newLayout => {
    if (!layoutsAreEqual(layout, newLayout)) {
      setLayout(newLayout);
    }
  };
  const layoutsAreEqual = (layout1, layout2) => {
    if (layout1.length !== layout2.length) {
      return false;
    }
    for (let i = 0; i < layout1.length; i++) {
      if (layout1[i].x !== layout2[i].x || layout1[i].y !== layout2[i].y) {
        return false;
      }
    }
    return true;
  };
  const handleResize = (index, width, height) => {
    const updatedLayout = [...layout];
    updatedLayout[index] = _objectSpread(_objectSpread({}, updatedLayout[index]), {}, {
      w: width,
      h: height
    });
    setLayout(updatedLayout);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ReactGridLayout, {
    className: "layout",
    draggableHandle: ".react-grid-dragHandleExample",
    rowHeight: 30,
    preventCollision: true,
    onLayoutChange: newLayout => handleLayoutChange(newLayout)
  }, gadgetData.map((item, index) => {
    const GadgetComponent = item.gadget;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.id,
      "data-grid": layout[index],
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #ccc',
        resize: 'both',
        position: 'relative' // Make sure the position is relative to position the Fab button.
      }
    }, /*#__PURE__*/_react.default.createElement(_reactResizable.Resizable, {
      width: layout[index].w,
      height: layout[index].h,
      onResize: (e, _ref2) => {
        let {
          size
        } = _ref2;
        handleResize(index, size.width, size.height);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
        border: '1px solid #ccc',
        resize: 'both'
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(GadgetComponent, null)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "react-grid-dragHandleExample",
      style: {
        cursor: 'move'
      }
    }, ":::"));
  })));
};
exports.DmsDragAndDropGrid = DmsDragAndDropGrid;
var _default = exports.default = DmsDragAndDropGrid;